<script>
export default {
    name: "ReverseOptions",

    data() {

        return {
            reverseIssue: false,
            reverseProcessed: false,
            prescriptions: [],
        };
    },

    props: {

        showModal: Boolean,
        drug: Object,
        patient: Object,
    },

    components: {

        "reverse-issue-form": () => import('./ReverseIssue.vue'),
        "reverse-processed-form": () => import('./ReverseProcess.vue'),
    },

    methods: {

        fetchPrescriptions() {
            this.$root.loading = true;
            return this.$http.get(`Pharmacy/GetPatientDrugIssueHistory?PrescriptionID=${this.drug.patientPrescriptionId}`).then(response => {
                this.prescriptions = response.data;
                this.$root.loading = false;
            }).catch(() => { this.$root.loading = false; });
        },
    },
}
</script>
<template>
    <tail-modal :show="showModal" dimension="w-10/12 md:w-1/4">
      <template v-slot:title>
        <h5 class="text-base font-medium">Reverse Options</h5>
      </template>
      <template v-slot:modal-body>
        <div class="w-full flex flex-col">
            <div class="w-full flex p-1 my-1" v-if="drug.issuedQty > 0">
                <button class="btn-danger text-sm w-full rounded" @click.prevent="() => { fetchPrescriptions().then(() => { reverseIssue=true; }) }"><i class="fa fa-undo"></i> Reverse Issue</button> 
            </div>
            <div class="w-full p-1 flex my-1" v-else>
                <button class="btn-warning text-sm w-full rounded" @click.prevent="reverseProcessed=true"><i class="fa fa-undo"></i> Reverse Processing</button>
            </div>
            <reverse-issue-form 
                :showModal="reverseIssue"
                :prescriptions="prescriptions"
                :patient="patient" 
                :drug="drug"
                @refresh="() => { $emit(`refresh`); }" 
                @closeModal="() => { reverseIssue=false; $emit(`closeModal`); }">
            </reverse-issue-form>
            <reverse-processed-form
                :showModal="reverseProcessed"
                :patient="patient"
                :drug="drug"
                @refresh="() => { $emit(`refresh`); }"
                @closeModal="() => { reverseProcessed=false; $emit(`closeModal`); }">
            </reverse-processed-form>
        </div>
      </template>
      <template v-slot:modal-footer>
        <button class="btn-danger btn-sm text-xs rounded" @click.prevent="$emit(`closeModal`)"><i class="fa fa-times"></i> Close</button>
      </template>
    </tail-modal>
</template>